module.exports = __webpack_public_path__ + "img/clothing212.efc5cb15.jpg";